export const MAP_AUTHORS_SLICE_NAME = 'mapAuthors' as const;
